import SegmentEntity from '../../store/presenter-slide-management-store/presentation-config-aggregate/segment-entity/segment-entity';
import {
  PresenterSlideEntity,
  IPresenterSlideEntity
} from '../../store/presenter-slide-management-store/presentation-config-aggregate/presenter-slide-entity/presenter-slide-entity';


export const buildPresenterSlideItemsFromSegmentsArray = (segments: SegmentEntity[]): IPresenterSlideEntity[] => {
  const slidesToReturn: IPresenterSlideEntity[] = [];
  for (const segment of segments) {
    slidesToReturn.push(...buildPresenterSlideItemsFromSegment(segment));
  }
  return slidesToReturn;
};

export const buildPresenterSlideItemsFromSegment = (segment:SegmentEntity): IPresenterSlideEntity[] => {
  return segment.getWorkingTracks().getCuePoints().map((cuePointEntity)=> new PresenterSlideEntity(segment, cuePointEntity));
};
